import { Download } from 'lucide-react';

export function AddYourCardComponent() {
  const handleDownloadApp = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    if (isIOS) {
      window.open('https://apps.apple.com/app/bloque', '_blank');
    } else if (isAndroid) {
      window.open(
        'https://play.google.com/store/apps/details?id=com.bloque',
        '_blank',
      );
    } else {
      window.open('https://bloque.app/download', '_blank');
    }
  };

  return (
    <div className="flex flex-col items-center space-y-8">
      <img
        src="/images/add-card.png"
        alt="Agregar tarjeta a tu billetera"
        className="w-full max-w-md"
      />

      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-white">
          Descarga nuestra app para agregar tu tarjeta
        </h3>
        <p className="text-sm text-gray-400">
          Agrega tu tarjeta Bloque a Apple Wallet o Google Wallet desde nuestra
          aplicación móvil
        </p>
      </div>
      <button
        type="button"
        onClick={handleDownloadApp}
        className="flex w-full items-center justify-center gap-3 rounded-xl bg-purple-600 px-8 py-4 text-lg font-semibold text-white transition-all hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <Download className="h-6 w-6" />
        Descargar App
      </button>
    </div>
  );
}
